import { useEffect } from "react";
import { data_fetch_api_resource } from "../../utils/http_functions";
import { i18n } from "../../config";
import { useQuery } from '@tanstack/react-query';

import { FormControl, Select, MenuItem, InputLabel, FormHelperText } from "@mui/material"

const useComers = (gas) => {
  const endpoint = gas ? "gas/leads/comers" : "leads/comers";
  const version = gas ? 2 : 1;
  
  return useQuery({
    queryKey: ['comers'],
    queryFn: () => data_fetch_api_resource(null, endpoint, version),
    staleTime: 1000 * 60 * 30
  })
}

const ComerOriginSelectField = ({ 
  input: { onChange, value }, 
  label = '', 
  readOnly = false, 
  onNoAvailableComersUpdate, 
  onUpdate = null, 
  gas, 
  meta, 
  ...rest 
}) => {

  const comersData = useComers(gas);

  useEffect(() => {
    if ((comersData.isSuccess && comersData.data.data.length == 0) 
      || comersData.isError) {
      onNoAvailableComersUpdate();
    }
  }, [comersData?.data?.data]);

  const handleChange = (event) => {
    onChange(event.target.value);
    if (typeof onUpdate === "function") {
      onUpdate(event.target.value);
    }
  };

  return (
    <div>
      <FormControl style={{ width: "100%"}}>
        <InputLabel>
          {(label || i18n.t('common:text.contractation_comer_origin')) + "*"}
        </InputLabel>
        <Select
          value={value}
          onChange={handleChange}
          autoWidth={true}
          disabled={readOnly}
          {...rest}
          error={!!(meta.touched && !meta.valid)}
        >
          {comersData.isSuccess &&
            comersData.data.data.map((c) => {
              return <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>;
            })
          }
        </Select>
      </FormControl>
      {!!(meta.touched && !meta.valid) &&
        <FormHelperText error={true}>
          {meta.error}
        </FormHelperText>
      }
    </div>
  );
};

export default ComerOriginSelectField;
